import React from "react";
import { View, StyleSheet } from "react-native";
import { AppColors } from "../../../../utility/AppColors";

interface ModalContainerProps {
  children: React.ReactNode;
}

const ModalContainer: React.FC<ModalContainerProps> = ({ children }) => {
  return (
    <View style={styles.container}>
      <View style={{ alignItems: "center" }}>{children}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    backgroundColor: AppColors.blackTrans_000000a8,
  },
});

export default ModalContainer;
